import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTree, MatTreeModule } from '@angular/material/tree';
import { CoordinationResultTreeNode } from './models/coordination-result-tree-node';
import { nameOf } from '../../../../../../core/functions/string-helpers';

@Component({
    selector: 'app-coordination-results-tree',
    imports: [MatTreeModule, MatButtonModule, MatIconModule, CommonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './coordination-results-tree.component.html',
})
export class CoordinationResultsTreeComponent implements OnChanges {
    @ViewChild('tree') tree!: MatTree<CoordinationResultTreeNode>;
    @Input() dataSource: CoordinationResultTreeNode[] = [];
    @Input() selectedNode: CoordinationResultTreeNode | null = null;
    @Output() leafSelected = new EventEmitter<{
        node: CoordinationResultTreeNode;
    }>();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes[nameOf<CoordinationResultsTreeComponent>('dataSource')]) {
            setTimeout(() => {
                this.tree?.expandAll();
            });
        }
    }

    onLeafClick(node: CoordinationResultTreeNode): void {
        this.leafSelected.emit({ node: node });
    }

    childrenAccessor = (node: CoordinationResultTreeNode) => {
        return node.children ?? [];
    };

    hasChild = (_: number, node: CoordinationResultTreeNode) => {
        return !!node.children && node.children.length > 0;
    };
}
